export default {"src":"https://images-cdn.curipod.com/d-bdb94e66/_next/static/media/axolotl.60c82212.svg","height":418,"width":815};